import {
  useParams,
} from 'react-router';

import {
  Flex,
} from 'web-styled';

import {
  Chat,
} from 'web-components';

const ClientMessages = () => {
  const { id, category } = useParams();

  return (
    <Flex fillSpace noScroll>
      <Chat
        id={id || 'new'}
        category={category || '1'}
      />
    </Flex>
  );
};

export default ClientMessages;
